import { render } from "./AccountActivityTab.vue?vue&type=template&id=20f42119"
import script from "./AccountActivityTab.vue?vue&type=script&lang=js"
export * from "./AccountActivityTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/AccountReceivable/AccountActivityTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20f42119"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20f42119', __exports__)) {
    api.reload('20f42119', __exports__)
  }
  
  module.hot.accept("./AccountActivityTab.vue?vue&type=template&id=20f42119", () => {
    api.rerender('20f42119', render)
  })

}


export default __exports__